import moment from 'moment';

import {
  IMAGE_FORMAT_OPTIONS,
  IMAGE_SIZE_OPTIONS,
  CROP_SIZE_OPTIONS,
  RESOLUTION_OPTIONS,
  BACKGROUND_OPTIONS,
  PLANOGRAM_TYPE,
} from 'static/Constants';

export const DOWNLOAD_FOLDER_PRODUCT_SETTING_SCHEMA = [
  { rowConfig: { gutter: [15, 15] } },
  [
    {
      colProps: {
        style: { flex: 1 },
      },
    },
    {
      name: 'productDataFormat',
      label: 'memberDataFormat',
      type: '',
    },
  ],
];

export const dropdownConfigs = () => [
  {
    name: 'productImageNamingFormat',
    options: PLANOGRAM_TYPE,
  },
  {
    name: 'productImageFormat',
    options: IMAGE_FORMAT_OPTIONS,
    renderLabel: (option) => {
      return option?.toUpperCase();
    },
  },
  {
    name: 'productImageSize',
    options: IMAGE_SIZE_OPTIONS,
  },
  {
    name: 'productCropSize',
    options: CROP_SIZE_OPTIONS,
    renderLabel: (option) => {
      return option === null ? 'No Crop' : `${option} Pixels`;
    },
  },
  {
    name: 'productResolution',
    options: RESOLUTION_OPTIONS,
    renderLabel: (option) => {
      return option === null ? 'Original' : option;
    },
  },
  {
    name: 'productBackground',
    options: BACKGROUND_OPTIONS,
  },
];

export const SCHEDULE_FORM_LAYOUT = {
  style: { flexWrap: 'nowrap' },
  labelCol: { flex: '80px' },
  wrapperCol: { flex: 1 },
};

const PLANOGRAM_OPTION = ['Front', 'Left', 'Right', 'Top', 'Bottom', 'Back'];
const MARKETING_OPTION = [...PLANOGRAM_OPTION, 'Other'];
const ADDITIONAL_OPTION = [
  'Ancillary',
  'Ecommerce',
  'Panel',
  'Brochure/ Sell Sheet',
  'General',
  'Logo',
  'Presentation',
  'Social media',
  'Audio',
  'Video',
];

export const DOWNLOAD_FOLDER_PRODUCT_HIERARCHY = {
  productUnit: [
    'productUnitPlanogram',
    'productUnitMarketing',
    'productUnitAdditionInformation',
  ],
  productDisplayShipper: [
    'productDisplayShipperPlanogram',
    'productDisplayShipperMarketing',
    'productDisplayShipperAdditionInformation',
  ],
  productInnerPack: [
    'productInnerPackPlanogram',
    'productInnerPackMarketing',
    'productInnerPackAdditionInformation',
  ],
  productCase: [
    'productCasePlanogram',
    'productCaseMarketing',
    'productCaseAdditionInformation',
  ],
  productMasterCase: [
    'productMasterCasePlanogram',
    'productMasterCaseMarketing',
    'productMasterCaseAdditionInformation',
  ],
  productPallet: [
    'productPalletPlanogram',
    'productPalletMarketing',
    'productPalletAdditionInformation',
  ],
};
export const DOWNLOAD_FOLDER_PRODUCT_CONFIGS = {
  //* productUnit: [
  productUnitPlanogram: PLANOGRAM_OPTION,
  productUnitMarketing: MARKETING_OPTION,
  productUnitAdditionInformation: ADDITIONAL_OPTION,
  //* productDisplayShipper: [
  productDisplayShipperPlanogram: PLANOGRAM_OPTION,
  productDisplayShipperMarketing: MARKETING_OPTION,
  productDisplayShipperAdditionInformation: ADDITIONAL_OPTION,
  //* productInnerPack: [
  productInnerPackPlanogram: PLANOGRAM_OPTION,
  productInnerPackMarketing: MARKETING_OPTION,
  productInnerPackAdditionInformation: ADDITIONAL_OPTION,
  //* productCase: [
  productCasePlanogram: PLANOGRAM_OPTION,
  productCaseMarketing: MARKETING_OPTION,
  productCaseAdditionInformation: ADDITIONAL_OPTION,
  //* productMasterCase: [
  productMasterCasePlanogram: PLANOGRAM_OPTION,
  productMasterCaseMarketing: MARKETING_OPTION,
  productMasterCaseAdditionInformation: ADDITIONAL_OPTION,
  //* productPallet: [
  productPalletPlanogram: PLANOGRAM_OPTION,
  productPalletMarketing: MARKETING_OPTION,
  productPalletAdditionInformation: ADDITIONAL_OPTION,
};
